import { useMainSelector } from './useMainSelector';

export const useUiState = () => {
  const {
    ui: { isLoading },
  } = useMainSelector();

  return { isLoading };
};
